import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expert-ans',
  templateUrl: './expert-ans.component.html',
  styleUrls: ['./expert-ans.component.css']
})
export class ExpertAnsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
